import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-horizontal-scroll-gallery',
  templateUrl: './horizontal-scroll-gallery.component.html',
  styleUrls: ['./horizontal-scroll-gallery.component.scss']
})
export class HorizontalScrollGalleryComponent implements OnInit {

  @Input() images: Array<string> = [];

  @Output() onFullScreenMode = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  activateFullscreen(i) {
    this.onFullScreenMode.emit(i);
  }

}
